import { CanvasCoordinates } from '../rendering';

export type PhotoEditorPen = 'free' | 'circle' | 'square' | 'text' | 'ruler';
export interface UserAnnotation {
  type: PhotoEditorPen;
  origin: CanvasCoordinates;
  color: string;
}

export interface FreeAnnotation extends UserAnnotation {
  traceLine: CanvasCoordinates[];
}

export interface CircleAnnotation extends UserAnnotation {
  end: CanvasCoordinates;
  x: number;
  y: number;
  radX: number;
  radY: number;
}

export interface SquareAnnotation extends UserAnnotation {
  end: CanvasCoordinates;
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface TextAnnotation extends UserAnnotation {
  screenOrigin: CanvasCoordinates;
  text: string;
  fontSize: number;
  angle?: number;
}

export interface RulerAnnotation extends UserAnnotation {
  end: CanvasCoordinates;
  measurement: string;
  fontSize: number;
}
